import styles from './ActionButton.module.css';

import type { FC, ReactNode } from 'react';

import classNames from 'classnames';

type ActionButtonProps = {
  children: ReactNode;
  onClick: () => void;
  className?: string;
  /**
   * The accessible name — required, because every use of this button is an icon with no text, and
   * an icon-only button without a name announces nothing at all (BUG-18). Doubles as the tooltip.
   */
  label: string;
};

export const ActionButton: FC<ActionButtonProps> = (props) => {
  const { children, onClick, className, label } = props;

  return (
    <button
      type="button"
      className={classNames(styles.container, className)}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      {children}
    </button>
  );
};
